import React from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import LoginWithPassword from './LoginWithPassword';
import LoginWithoutPassword from './LoginWithoutPassword';
import ResetPassword from './ResetPassword';
import Welcome from './Welcome/Welcome';

const LoginPages = () => {
    const { path } = useRouteMatch();
    const {
        location: { state: locationState },
    } = useHistory();

    return (
        <div className="container my-5" style={{ maxWidth: '800px' }}>
            <div className="row">
                <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                    <Switch>
                        <Route path={path} exact>
                            <LoginWithPassword email={locationState?.email ?? ''} />
                        </Route>

                        <Route path={`${path}/magic-link`}>
                            <LoginWithoutPassword />
                        </Route>

                        <Route path={`${path}/reset-password`}>
                            <ResetPassword />
                        </Route>

                        <Route path={`${path}/welcome`}>
                            <Welcome />
                        </Route>
                    </Switch>
                </div>
            </div>
        </div>
    );
};

LoginPages.propTypes = {};

export default LoginPages;
